import { takeLatest, put } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';

import http from 'app/services/httpService';
import { callWrapperSaga } from 'app/services/sagaService';
import apiEndpoints from 'routes/apiEndpoints';

import {
  getTransactionSummaryInit,
  getTransactionSummarySuccess,
  getTransactionSummaryFailure,
  getInboundPaymentInit,
  getInboundPaymentSuccess,
  getInboundPaymentFailure,
  getOutboundPaymentInit,
  getOutboundPaymentSuccess,
  getOutboundPaymentFailure,
  getKycCountInit,
  getKycCountSuccess,
  getKycCountFailure,
} from './dashboardSlice';

// Actions (optional to re-export)
export const fetchTransactionSummary = createAction('dashboard/fetchTransactionSummary');
export const fetchInboundPayment = createAction('dashboard/fetchInboundPayment');
export const fetchOutboundPayment = createAction('dashboard/fetchOutboundPayment');
export const fetchKycCount = createAction('dashboard/fetchKycCount');

// Saga Workers

function* fetchTransactionSummarySaga(action) {
  yield put(getTransactionSummaryInit());

  try {
    const params = action.payload || {};

    // GET with params as query string
    const response = yield callWrapperSaga(() =>
      http.get(apiEndpoints.transactionSummary, { params }),
    );

    // Pass full response data (including pagination if any)
    yield put(getTransactionSummarySuccess(response.data));
  } catch (error) {
    yield put(
      getTransactionSummaryFailure(error?.response?.data?.message || 'Something went wrong'),
    );
  }
}

function* fetchInboundPaymentSaga(action) {
  yield put(getInboundPaymentInit());
  try {
    const params = action.payload || {};
    const response = yield callWrapperSaga(() => http.get(apiEndpoints.inboundPayment, { params }));

    const inboundList = response.data?.data || [];

    yield put(getInboundPaymentSuccess(inboundList));
  } catch (error) {
    yield put(getInboundPaymentFailure(error?.response?.data?.message || 'Something went wrong'));
  }
}

function* fetchOutboundPaymentSaga(action) {
  yield put(getOutboundPaymentInit());
  try {
    const params = action.payload || {};
    const response = yield callWrapperSaga(() => http.get(apiEndpoints.outboundPyment, { params }));

    const outboundList = response.data?.data || [];

    yield put(getOutboundPaymentSuccess(outboundList));
  } catch (error) {
    yield put(getOutboundPaymentFailure(error?.response?.data?.message || 'Something went wrong'));
  }
}

function* fetchKycCountSaga(action) {
  yield put(getKycCountInit());
  try {
    const params = action.payload || {};
    const response = yield callWrapperSaga(() => http.get(apiEndpoints.kycCount, { params }));

    yield put(getKycCountSuccess(response.data));
  } catch (error) {
    yield put(getKycCountFailure(error?.response?.data?.message || 'Something went wrong'));
  }
}


// Saga Watcher
function* dashboardSaga() {
  yield takeLatest(fetchTransactionSummary.type, fetchTransactionSummarySaga);
  yield takeLatest(fetchInboundPayment.type, fetchInboundPaymentSaga);
  yield takeLatest(fetchOutboundPayment.type, fetchOutboundPaymentSaga);
  yield takeLatest(fetchKycCount.type, fetchKycCountSaga);
}

export default dashboardSaga;
